<template>
    <div class="p-30">
        <div class="mb-15">
            <el-button plain @click="$router.go(-1)">返回</el-button>
        </div>
        <el-form class="mb-30">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="试卷名称：">
                        <el-input v-model="paperName" placeholder="请输入试卷名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="试卷分类：">
                        <el-cascader v-model="categoryId" placeholder="请选择课程分类" :options="paperCategory" clearable
                            :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true }">
                        </el-cascader>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <div class="flex jc-fe">
                        <el-button type="primary" @click="search()">
                            <i class="el-icon-search" style="margin-right: 5px;"></i>查询
                        </el-button>
                        <el-button @click="search('refresh')">
                            <i class="el-icon-refresh" style="margin-right: 5px;"></i>重置
                        </el-button>
                    </div>
                </el-col>
            </el-row>
        </el-form>


        <!-- <el-dropdown placement="top">
            <el-button style="margin-bottom: 20px;" type="primary" plain icon="el-icon-plus">
                创建试卷
            </el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>自定义创建</el-dropdown-item>
                <el-dropdown-item>从模版创建</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown> -->

        <div v-for="(p, i) in paperList" :key="i" class="class-card pt-15 pb-15 pl-30 pr-30 mb-20 f-12">
            <div class="flex jc-sb mb-15 f-12">
                <div class="flex jc-fs f-18">
                    {{ p.paperName }}
                    <!-- <div v-if="p.publishStatus == 0" class="status-label bg-67c23a">待发布</div>
                    <div v-if="p.publishStatus == 1" class="status-label bg-409eff">已发布</div>
                    <div v-if="p.publishStatus == 2" class="status-label bg-e6a23c">已下线</div> -->
                </div>
                <div class="flex jc-fe">
                    {{ p.totalQuestions }} 大题
                    <div class="pl-10 pr-10">|</div>
                    {{ p.totalSubquestions }} 小题
                    <div class="pl-10 pr-10">|</div>
                    总分 {{ p.totalScore }}分
                </div>
            </div>
            <div class="flex jc-fs mb-15">
                <div class="mr-20">试卷分类：{{ p.categoryName }}</div>
                <!-- <div>所属学校/组织：{{ p.schoolName }}</div> -->
            </div>
            <div class="flex jc-sb">
                <div>
                    【{{ p.creatorName }}】创建于{{ p.createTimeStr }}
                </div>
                <div class="flex jc-fe f-18 t-c">
                    <div @click="toPreview(p)" class="ml-30">
                        <i class="el-icon-view c-409eff mr-5"></i>预览
                    </div>
                    <div @click="toCreate(p)" class="ml-30">
                        <i class="el-icon-edit c-409eff mr-5"></i>使用
                    </div>
                </div>
            </div>
        </div>

        <el-empty v-if="paperList && paperList.length == 0" description="暂无数据"></el-empty>

        <el-pagination class="flex jc-fe" @size-change="pageSizeChange" @current-change="pageNoChange"
            :current-page="pageNo" :page-sizes="[10, 20, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </div>
</template>

<script>
import { paperList } from '@/api/index2';
import { formatDate } from '@/utils/utils';


import { encrypt, decrypt } from '@/api/common_encrypt';

export default {
    name: 'paperTemList',
    components: {},
    data() {
        return {
            loading: false,

            paperCategory: [],

            paperName: "",
            categoryId: "",
            searchForm: {},

            pageNo: 1,
            pageSize: 10,
            total: 0,

            paperList: [],

        };
    },
    mounted() {
        this.getCategory();
        this.getList();
    },
    methods: {
        getCategory() {

        },

        pageNoChange(e) {
            this.pageNo = e;
            this.getList();
        },
        pageSizeChange(e) {
            this.pageSize = e;
            this.getList();
        },
        search(msg) {
            this.pageNo = 1;
            if (msg == "refresh") {
                this.paperName = null;
                this.categoryId = null;
                this.searchForm = {};
            }
            this.searchform = {
                paperName: this.paperName,
                categoryId: this.categoryId,
            }
            this.getList()
        },
        getList() {
            this.loading = true;
            let info = {
                page: this.pageNo,
                pageSize: this.pageSize,
                isTemplate: 1,

                ...this.searchform,
            };

            paperList(info).then((res) => {
                if (res.result == 1) {

                    console.log('res :>> ', res);
                    // return
                    this.total = res.data.total;
                    this.pageNo = res.data.pageNum;
                    this.paperList = res.data.list;

                    this.paperList.forEach(p => {
                        p.createTimeStr = formatDate(new Date(p.createTime), 'yyyy-MM-dd hh:mm:ss')
                    });

                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
                this.loading = false;
            });



        },
        async copyToClipboard(c) {
            try {
                await navigator.clipboard.writeText("aaasss");
                this.$message({
                    message: '复制成功',
                    type: 'success'
                })
            } catch (err) {
                this.$message({
                    message: '复制失败',
                    type: 'warning'
                });
            }
        },

        toPreview(p) {
            let param = {
                paper: p
            }
            this.$router.push({
                path: '/paperPreview',
                query: {
                    param: encrypt(JSON.stringify(param)),
                }
            });
        },

        toCreate(p) {
            let param = {
                paper: p,
            }
            this.$router.push({
                path: '/paperDetail',
                query: {
                    param: encrypt(JSON.stringify(param)),
                }
            });
        },

    }
};
</script>

<style lang='scss' scoped>
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin-bottom: 0px;
}

.class-card {
    border-radius: 20px;
    border: 1px solid #ebeef5;
    transition: box-shadow 0.3s ease, transform 0.3s ease;
}

.class-card:hover {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15);
    // transform: translateY(-1px);
}

.status-label {

    width: 46px;
    height: 17px;
    line-height: 17px;
    border-radius: 9px;

    color: #fff;
    font-size: 10px;
    text-align: center;
    margin-left: 5px;
}
</style>
